import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "../Context/AuthContext";
import { LogIn, LogOut, User, Sparkles } from "lucide-react";

export default function Navbar({ onLoginClick }) {
  const { user, logout } = useAuth();

  return (
    <nav className="fixed top-0 left-0 w-full z-50 backdrop-blur-md bg-black/40 border-b border-fuchsia-500/30 shadow-[0_4px_20px_rgba(255,0,255,0.1)]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex items-center gap-2"
        >
          <motion.div
            animate={{ rotate: [0, 360] }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          >
            <Sparkles className="text-fuchsia-400" size={24} />
          </motion.div>
          <h1 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 via-fuchsia-500 to-purple-600 bg-clip-text text-transparent drop-shadow-[0_0_10px_rgba(255,0,255,0.5)]">
            Yash <span className="text-fuchsia-400">Makwana</span>
          </h1>
        </motion.div>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#home" className="text-gray-300 hover:text-fuchsia-400 transition-colors text-md font-semibold" >
            Home
          </a>
          <a href="#about" className="text-gray-300 hover:text-fuchsia-400 transition-colors text-md font-semibold">
            About
          </a>
          <a href="#contact" className="text-gray-300 hover:text-fuchsia-400 transition-colors text-md font-semibold">
            Contact
          </a>
        </div>

        {/* Auth Section */}
        <div>
          {user ? (
            <div className="flex items-center space-x-4">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                className="flex items-center gap-2 px-4 py-2 bg-fuchsia-500/10 border border-fuchsia-500/30 rounded-lg"
              >
                <User size={16} className="text-fuchsia-400" />
                <span className="text-white text-sm hidden sm:inline">Welcome, {user.email.split('@')[0]}</span>
              </motion.div>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={logout}
                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:from-red-700 hover:to-red-800 transition-all shadow-lg"
              >
                <LogOut size={18} />
                <span className="hidden sm:inline">Logout</span>
              </motion.button>
            </div>
          ) : (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onLoginClick}
              className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-fuchsia-500 to-purple-600 text-white rounded-lg hover:shadow-[0_0_20px_rgba(255,0,255,0.5)] transition-all font-semibold"
            >
              <LogIn size={18} />
              Login
            </motion.button>
          )}
        </div>
      </div>
    </nav>
  );
}
